import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Navigate } from 'react-router';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: 'admin' | 'manager' | 'staff';
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredRole,
}) => {
  const { user, profile, currentUserRole, loading, currentOrganization } =
    useAuth();

  console.log(
    'ProtectedRoute: user:',
    !!user,
    'profile:',
    !!profile,
    'currentUserRole:',
    currentUserRole,
    'loading:',
    loading
  );

  if (loading || (user && !currentOrganization)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg">
          <svg
            className="animate-spin h-8 w-8 text-black dark:text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        </div>
      </div>
    );
  }

  if (!loading && !user) {
    console.log('ProtectedRoute: No user, redirecting to auth');
    return <Navigate to="/auth" replace />;
  }

  // Allow access if no role is required or while user data is still loading
  if (!loading && requiredRole && currentUserRole) {
    const roleHierarchy = { admin: 3, manager: 2, staff: 1 };
    const userLevel = roleHierarchy[currentUserRole];
    const requiredLevel = roleHierarchy[requiredRole];

    if (userLevel < requiredLevel) {
      console.log('ProtectedRoute: Insufficient role, redirecting to home');
      return <Navigate to="/" replace />;
    }
  }

  console.log('ProtectedRoute: Access granted');
  return <>{children}</>;
};

export default ProtectedRoute;
